export default "__VITE_PUBLIC_ASSET__e5d59185__"